<template>
  <div class="index-box">
    <div class="speImg" @click="apClisk">
      <div
        class="topImgL"
        :style="{ backgroundImage: `url(${digitalCampus})` }"
      >
        <img class="jinruimg" :src="btnShuzixiaoyuan" />
        <div class="jinru">点击进入</div>
      </div>
      <img class="topImgR" :src="btnDituNor" />
    </div>
  </div>
</template>
<script>
import download from "@/utils/VR";
import digitalCampus from "@/assets/image/almaMater/digitalCampus.png";
import btnDituNor from "@/assets/image/almaMater/btn_ditu@2x.png";
import btnShuzixiaoyuan from "@/assets/image/almaMater/btn_shuzixiaoyuan_nor.png";

export default {
  data() {
    return {
      digitalCampus,
      btnDituNor,
      btnShuzixiaoyuan,
    };
  },
  methods: {
    apClisk() {
      let url = "https://www.720yun.com/t/d9bjOO4Otn3?scene_id=3473174";
      download(url);
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .speImg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;

    .topImgL {
      position: relative;
      display: flex;
      width: 95vw;
      height: 200px;
      border-radius: 10px;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      margin-bottom: 10px;
      background-size: cover;
      .jinruimg {
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
      .jinru {
        position: relative;
        width: 100%;
        height: 30px;
        line-height: 30px;
        background: rgba(0, 0, 0);
        opacity: 0.7;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        text-align: center;
        padding: 0;
        color: #fff;
        font-size: 0.8rem;
        margin-top: 170px;
      }
    }
    .topImgR {
      position: relative;
      display: flex;
      width: 95vw;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Campus.vue